import styled from "styled-components";

import { formatarData } from "../../Funcoes/FormatarData";
import { formatValorMoney } from '../../Funcoes/FormatValorMoney';

import Tabela from '../../Componentes/Utils/Tabela';

const Container = styled.div`
    width: 100%;
    background-color: #EBEBEB;
    border-radius: 15px;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 10px;
`
const Cabecalho = styled.div`
    width: 100%;
    height: 50px;
    background-color: #dbdbdb;
    box-sizing: border-box;
    display: flex;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
`
const Titulo = styled.h2`
    margin: 0;
    font-size: 14px;
    font-weight: bold;
`
const Corpo = styled.div`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    padding: 10px;
`
const TableCell = styled.td`
    text-align: ${(props) => {
        if (props.align === "left") return "left !important";
        if (props.align === "center") return "center !important";
        if (props.align === "right") return "right !important";
        return "left !important";
    }};
`


const ContainerFolgaCampo = ({ folgasCampo }) => {
    return (
        <>
            <Container>
                <Cabecalho>
                    <Titulo>FOLGAS DE CAMPO</Titulo>
                </Cabecalho>
                <Corpo>
                    <Tabela>
                        <thead>
                            <tr>
                                <th>VALOR</th>
                                <th>DATA</th>
                                <th>DIAS GOZO</th>
                                <th>PRÓXIMA FOLGA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                folgasCampo?.length > 0 ? folgasCampo.map( item => (
                                    <tr key={ item.id } >
                                        <TableCell align="left" >{ "R$ " + ( item?.valor ? formatValorMoney( item.valor ) : formatValorMoney( "0.00" ) ) }</TableCell>
                                        <TableCell align="center" >{ item?.data ? formatarData( item.data ) : '-' }</TableCell>
                                        <TableCell align="center" >{ item.dias_gozo }</TableCell>
                                        <TableCell align="center" >{ item?.prox_folga ? formatarData( item.prox_folga ) : '-' }</TableCell>
                                    </tr>
                                )) : (
                                    <tr>
                                        <TableCell align="center" colSpan={4} >
                                            COLABORADOR NÃO POSSUÍ FOLGAS DE CAMPO
                                        </TableCell>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Tabela>
                </Corpo>
            </Container>
        </>
    )
}

export default ContainerFolgaCampo;